import classNames from "@casino/external/classNames";

type Props = {
  badge: { color: string; gradient?: string };
};

const GameBadge: FC<Props> = ({ children, badge }) => (
  <div
    className={classNames(
      "absolute z-2 top-0 left-1/2 -translate-x-1/2 inline-flex items-center rounded-t-[2px] px-1",
      !badge.gradient && badge.color,
    )}
    style={badge.gradient ? { background: badge.gradient } : undefined}
  >
    <span className="text-[9px] font-semibold leading-3 text-white whitespace-nowrap">
      {children}
    </span>
  </div>
);

export default GameBadge;
